import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function MatchInfoButtonGroup({
  matchType,
  activeTab,
  numberOfTeeTimes,
  kickerBetMatchType,
}) {
  const metchPlayTab = () => {
    if (numberOfTeeTimes > 1) {
      if (kickerBetMatchType === 0) {
        return ["Scoring", "Quota", "Scorecard"];
      }
      return ["Scoring", "Scorecard"];
    }
    if (numberOfTeeTimes === 1) {
      if (kickerBetMatchType === 0) {
        return ["Scoring", "Match", "Quota", "Scorecard"];
      }
      return ["Scoring", "Match", "Scorecard"];
    }
    return ["Scoring", "Match", "Scorecard"];
  };

  const ButtonGroup = {
    0: ["Scoring", "Quota", "Scorecard"], //   0: "Quota",
    1: ["Scoring", "Scorecard"], //   1: "Stroke Play (Net)",
    2: ["Scoring", "Scorecard"], //   2: "Stroke Play Gross",
    3: metchPlayTab(), //   3: "Match Pla Gross",
    4: ["Scoring", "Scorecard"], //   4: "Skins Gross",
    5: ["Scoring", "Scorecard"], //   5: "Skins (Net)",
    6: ["Scoring", "Scorecard"], //   6: "Birdie Pool Gross",
    7: ["Scoring", "Scorecard"], //   7: "Birdie Pool (Net)",
    8: metchPlayTab(), //   8: "Match Pla Net",
  };
  const [state, setState] = useState("Scoring");

  useEffect(() => {
    activeTab(state);
  }, [activeTab, setState, state]);

  const [searchParams] = useSearchParams();
  const hole = searchParams.get("hole");
  const scorecard = searchParams.get("scorecard");

  useEffect(() => {
    if (hole) {
      setState("Scoring");
    }
    if (scorecard) {
      setState("Scorecard");
    }
  }, [hole, scorecard]); // redirect to first tab after picking a hole w/o props drilling

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        {ButtonGroup[matchType].map((i) => (
          <Button
            key={i + Math.random(999)}
            title={i}
            active={i === state}
            setActive={() => setState(i)}
          />
        ))}
      </div>
    </div>
  );
}

export { MatchInfoButtonGroup };

MatchInfoButtonGroup.propTypes = {
  matchType: PropTypes.number.isRequired,
  activeTab: PropTypes.func.isRequired,
  numberOfTeeTimes: PropTypes.number.isRequired,
  kickerBetMatchType: PropTypes.number.isRequired,
};

export function Button({ title, active, setActive }) {
  return (
    <div
      aria-hidden
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: 40,
        width: active ? "150%" : "100%",
        // transform: active ? "scale(1.1) translate(0px, -2px)" : null,
        borderRadius: active ? "8px 8px 0px 0px" : "0px 8px 0px 0px",
        borderWidth: active ? "2px 2px 0px 2px" : "2px 2px 0px 0px",
        borderStyle: "solid",
        borderColor: active ? "#2977A4" : "#C6C7C8",
        background: active ? "#2977A4" : "white",
        fontFamily: "SF Pro Text",
        fontWeight: 700,
        fontSize: 12,
        lineHeight: 18,
        letterSpacing: -0.08,
        textTransform: "uppercase",
        color: !active ? "rgba(16, 21, 25, 0.3)" : "rgba(255, 255, 255, 0.95)",
      }}
      onClick={setActive}
      type="button"
    >
      {title}
    </div>
  );
}

Button.propTypes = {
  title: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
};
